<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card
    [title]="pageTitle"
    desc="Complete los datos de la plantilla de invitación"
  >
    <!-- Loading -->
    @if (loading) {
      <div class="flex justify-center items-center py-12">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400"
          >Cargando datos...</span
        >
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div
        class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
      >
        <div class="flex items-center gap-3">
          <svg
            class="w-5 h-5 text-error-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <p class="text-error-600 dark:text-error-400">{{ error }}</p>
        </div>
      </div>
    }

    <!-- Formulario -->
    @if (!loading) {
      <form
        (ngSubmit)="guardar()"
        #templateForm="ngForm"
        class="space-y-5"
      >
        <!-- Nombre -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Nombre <span class="text-error-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            [(ngModel)]="name"
            required
            placeholder="Ej: Plantilla profesional de bienvenida"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Asunto -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Asunto del correo <span class="text-error-500">*</span>
          </label>
          <input
            type="text"
            name="subject"
            [(ngModel)]="subject"
            required
            [placeholder]="subjectPlaceholder"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>

        <!-- Placeholders info -->
        <div
          class="rounded-lg border border-brand-200 bg-brand-50 p-4 dark:border-brand-500/20 dark:bg-brand-500/10"
        >
          <p
            class="mb-2 text-sm font-medium text-brand-700 dark:text-brand-400"
          >
            Variables disponibles para usar en el contenido:
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            @for (ph of placeholders; track ph.token) {
              <div class="flex items-start gap-2">
                <code
                  class="shrink-0 rounded bg-white px-1.5 py-0.5 text-xs font-mono text-brand-600 dark:bg-white/10 dark:text-brand-300 border border-brand-200 dark:border-brand-500/30"
                  >{{ ph.token }}</code
                >
                <span
                  class="text-xs text-brand-600 dark:text-brand-400 pt-0.5"
                  >{{ ph.desc }}</span
                >
              </div>
            }
          </div>
        </div>

        <!-- Cuerpo HTML -->
        <div>
          <div class="mb-1.5 flex items-center justify-between">
            <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
              Cuerpo HTML <span class="text-error-500">*</span>
            </label>
            <button
              type="button"
              (click)="abrirPreview()"
              [disabled]="!bodyHtml.trim() || !subject.trim()"
              title="Requiere asunto y cuerpo HTML"
              class="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500/30 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3.5 w-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              Vista previa
            </button>
          </div>
          <textarea
            name="bodyHtml"
            [(ngModel)]="bodyHtml"
            required
            rows="10"
            [placeholder]="bodyHtmlPlaceholder"
            class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed font-mono resize-y"
          ></textarea>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Contenido principal del correo en formato HTML.
          </p>
        </div>

        <!-- Cuerpo texto plano -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            Cuerpo en texto plano
            <span class="ml-1 text-xs font-normal text-gray-400"
              >(opcional)</span
            >
          </label>
          <textarea
            name="bodyText"
            [(ngModel)]="bodyText"
            rows="5"
            placeholder="Versión en texto plano para clientes de correo que no soportan HTML..."
            class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed resize-y"
          ></textarea>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Alternativa en texto plano para clientes de correo sin soporte HTML.
          </p>
        </div>

        <!-- Fila: Estilo y Color -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <!-- Estilo preestablecido -->
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Estilo
            </label>
            <select
              name="stylePreset"
              [(ngModel)]="stylePreset"
              class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <option value="">Sin estilo definido</option>
              @for (preset of stylePresets; track preset.value) {
                <option [value]="preset.value">{{ preset.label }}</option>
              }
            </select>
          </div>

          <!-- Color primario -->
          <div>
            <label
              class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Color primario
            </label>
            <div class="flex items-center gap-3">
              <input
                type="color"
                name="primaryColor"
                [(ngModel)]="primaryColor"
                class="h-11 w-14 cursor-pointer rounded-lg border border-gray-300 bg-transparent p-1 shadow-theme-xs focus:outline-hidden dark:border-gray-700"
              />
              <span
                class="text-sm font-mono text-gray-600 dark:text-gray-400"
                >{{ primaryColor }}</span
              >
            </div>
          </div>
        </div>

        <!-- URL del logo -->
        <div>
          <label
            class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            URL del logo
            <span class="ml-1 text-xs font-normal text-gray-400"
              >(opcional)</span
            >
          </label>
          <input
            type="url"
            name="logoUrl"
            [(ngModel)]="logoUrl"
            placeholder="https://ejemplo.com/logo.png"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            URL pública de la imagen del logo a mostrar en el correo.
          </p>
        </div>

        <!-- Plantilla por defecto -->
        <div class="flex items-start gap-3">
          <div class="flex items-center h-5 mt-0.5">
            <input
              type="checkbox"
              id="isDefault"
              name="isDefault"
              [(ngModel)]="isDefault"
              class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-900 cursor-pointer"
            />
          </div>
          <div>
            <label
              for="isDefault"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer"
            >
              Establecer como plantilla por defecto
            </label>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              Esta plantilla se usará automáticamente al enviar invitaciones sin
              especificar una plantilla.
            </p>
          </div>
        </div>

        <!-- Botones -->
        <div
          class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700"
        >
          <app-button
            variant="outline"
            type="button"
            (btnClick)="cancelar()"
          >
            Cancelar
          </app-button>
          <app-button
            variant="primary"
            type="submit"
            [disabled]="saving"
          >
            {{
              saving
                ? 'Guardando...'
                : isEditing
                  ? 'Actualizar plantilla'
                  : 'Crear plantilla'
            }}
          </app-button>
        </div>
      </form>
    }
  </app-component-card>
</div>

<!-- Modal previsualización HTML (renderer del backend, idéntico al correo real) -->
@if (showPreview) {
  <div
    class="fixed inset-0 z-modal flex items-center justify-center bg-black/50 p-4"
    (click)="cerrarPreview()"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex flex-col w-full max-w-4xl h-[85vh] max-h-[90vh] rounded-xl bg-white shadow-2xl dark:bg-gray-900 overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Cabecera -->
      <div
        class="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 dark:border-gray-700 shrink-0"
      >
        <div class="flex items-center gap-2 min-w-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 shrink-0 text-gray-500 dark:text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <div class="min-w-0">
            <p
              class="text-sm font-medium text-gray-700 dark:text-gray-300 truncate"
            >
              Vista previa del correo
            </p>
            @if (previewSubject) {
              <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
                Asunto: {{ previewSubject }}
              </p>
            }
          </div>
        </div>
        <button
          type="button"
          (click)="cerrarPreview()"
          class="shrink-0 rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none dark:hover:bg-gray-800 dark:hover:text-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Cuerpo: loading / error / iframe responsive -->
      <div class="flex-1 min-h-0 overflow-hidden bg-gray-100 dark:bg-gray-950">
        @if (previewLoading) {
          <div class="flex h-full flex-col items-center justify-center gap-3">
            <div
              class="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"
            ></div>
            <span class="text-sm text-gray-500 dark:text-gray-400"
              >Generando vista previa...</span
            >
          </div>
        } @else if (previewError) {
          <div
            class="flex h-full flex-col items-center justify-center gap-3 px-6 text-center"
          >
            <svg
              class="h-8 w-8 text-error-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p class="text-sm text-error-600 dark:text-error-400">
              {{ previewError }}
            </p>
          </div>
        } @else if (previewSafeHtml) {
          <iframe
            [srcdoc]="previewSafeHtml"
            class="h-full w-full border-0 bg-white"
            sandbox
            title="Vista previa del correo"
          >
          </iframe>
        }
      </div>
    </div>
  </div>
}
